<template>
  <div>
    <v-card>
      <v-card-title>กรุณาเลือกวิชาที่จะจัดคิว</v-card-title>
      <v-card-text>
        <div style="font-size: 18px; line-height: 1.5em;">
          มีบางวิชาที่คุณทำการลงทะเบียน มีผู้ลงทะเบียนครบจำนวนแล้ว (วิชาที่ยังไม่เต็มระบบได้ลงทะเบียนให้ท่านเรียบร้อยแล้ว) โดยปกติระบบจะนำเข้าแถวคอยโดยอัตโนมัติ
          แต่จำนวนวิชาในแถวคอยของคุณเกินกำหนด กรุณาเลือกวิชาที่ต้องการเข้าแถวคอย หรือลบวิชาเดิมที่มีอยู่ในแถวคอยออกให้พอดีจำนวนก่อนเข้าคิวอีกครั้ง
          <br>
          \\save rejected ไว้ใน storage
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="warning"
          @click="confirm_regis_dialog = false"
        >{{ $t("pre_regis_add_subject.back") }}</v-btn>
        <v-btn
          dark
          color="deep-orange"
          @click="submit()"
        >{{ $t("pre_regis_add_subject.confirm") }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>